import { render } from "./RegistroSanitorioListo.vue?vue&type=template&id=49924412"
import script from "./RegistroSanitorioListo.vue?vue&type=script&lang=js"
export * from "./RegistroSanitorioListo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__